import React from 'react';
import { Card, Typography, Tag, Space, theme } from 'antd';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import WorkspaceFileCard from './WorkspaceFileCard';

dayjs.extend(relativeTime);

const { Text, Paragraph } = Typography;

const stripHtml = (html) => (html ? String(html).replace(/<[^>]*>/g, '') : '');

const WorkspaceCommentCard = ({ comment, embedded = false, onPreviewFile }) => {
  const { token } = theme.useToken();
  const replies = Array.isArray(comment.replies) ? comment.replies : [];
  const visibility = comment.visibility || 'internal';
  const creator = comment.extra?.creator;
  const portalAuthor = comment.extra?.portal_author;
  const name =
    creator?.extra?.full_name ||
    [creator?.first_name, creator?.last_name].filter(Boolean).join(' ') ||
    portalAuthor?.full_name ||
    'Unknown';

  const meta = (
    <Space wrap size="small" style={{ justifyContent: 'space-between', width: '100%' }}>
      <Text strong style={{ fontSize: embedded ? 13 : 14 }}>
        {name}
      </Text>
      <Space size="small">
        <Tag color={visibility === 'customer_visible' ? 'blue' : 'default'}>
          {visibility === 'customer_visible' ? 'Customer visible' : 'Internal'}
        </Tag>
        <Text type="secondary" style={{ fontSize: 12 }}>
          {comment.created_at ? dayjs(comment.created_at).fromNow() : ''}
        </Text>
      </Space>
    </Space>
  );

  const media = Array.isArray(comment.media) ? comment.media : [];

  const body = (
    <>
      {comment.body ? (
        <Paragraph
          style={{ marginBottom: 0, marginTop: embedded ? 6 : 8, whiteSpace: 'pre-wrap' }}
          ellipsis={{ rows: embedded ? 8 : 12, expandable: true }}
        >
          {stripHtml(comment.body)}
        </Paragraph>
      ) : null}
      {media.length > 0 ? (
        <div
          style={{
            marginTop: token.marginXS,
            display: 'flex',
            flexDirection: 'column',
            gap: token.marginXXS,
          }}
        >
          {media.map((m) => (
            <WorkspaceFileCard
              key={m.id}
              media={m}
              compact
              onPreview={onPreviewFile ? () => onPreviewFile(m) : undefined}
            />
          ))}
        </div>
      ) : null}
    </>
  );

  const flatReplyList =
    replies.length > 0 ? (
      <div style={{ marginTop: token.marginSM }}>
        {replies.map((r) => (
          <div
            key={r.id}
            style={{
              marginTop: token.marginXS,
              paddingLeft: token.padding,
              borderLeft: `2px solid ${token.colorBorderSecondary}`,
            }}
          >
            <WorkspaceCommentCard comment={r} embedded onPreviewFile={onPreviewFile} />
          </div>
        ))}
      </div>
    ) : null;

  if (embedded) {
    return (
      <div className="workspace-comment-embedded">
        {meta}
        {body}
        {flatReplyList}
      </div>
    );
  }

  return (
    <div style={{ marginBottom: 'var(--ant-margin-sm)' }}>
      <Card
        size="small"
        className="workspace-feed-card"
        styles={{
          body: { padding: 'var(--ant-padding)' },
        }}
        style={{
          marginBottom: flatReplyList ? 0 : undefined,
          border: '1px solid var(--varexe-border-color)',
        }}
      >
        <Space orientation="vertical" size={4} style={{ width: '100%' }}>
          {meta}
          {body}
        </Space>
      </Card>
      {flatReplyList}
    </div>
  );
};

export default WorkspaceCommentCard;
